import{Z as o,d as s}from"./p-DF5TxB8E.js";const t=o;const p=s;export{t as ZprDropdownMenu,p as defineCustomElement};
//# sourceMappingURL=zpr-dropdown-menu.js.map